import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';

const Address = ({
  data,
  handleAddressSelect,
  editPopup,
  setEditPopup,
  onDelete,
  type,
}) => {
  const displayNameLabel = (data, type) => {
    if (Number(type) === 2) {
      return (
        <span className="flex fw-600 fs-md p-0 w-100 text-accent-forground">
          {data.clinic_name !== '' ? (
            <>{data.clinic_name}</>
          ) : (
            <>{data.nameLabel}</>
          )}
        </span>
      );
    }
    if (Number(type) === 3 || Number(type) === 5) {
      return (
        <span className="flex fw-600 fs-md p-0 w-100 text-accent-forground">
          {data.nameLabel}
        </span>
      );
    }
    if (Number(type) === 4) {
      return (
        <span className="flex fw-600 fs-md p-0 w-100 text-accent-forground">
          {data.nameLabel}
        </span>
      );
    }
  };
  return (
    <div className="flex gap-8 mt-3 addressCard addressSelected flex-1 border border-lightgray p-4 rounded-lg">
      <div className="bodyLeftRowq flex-1">
        <div
          className="bodyLeftRowData cursor w-100"
          onClick={() => handleAddressSelect(data)}
        >
          <div className="flex justify-between items-center mb-3">
            {displayNameLabel(data, type)}
            {data?.speciality && (
              <div className="flex gap-2 flex-shrink-0 items-center">
                <span className="fs-13 badge-gray-100 text-accent-forground rounded-full p-1-5 px-3">
                  {data?.speciality}
                </span>
              </div>
            )}
          </div>
          {data.clinic_name !== '' &&
            data.nameLabel !== '' &&
            Number(type) === 2 && (
              <span class="flex fw-600 fs-md p-0 w-100 text-accent-forground">
                {data.nameLabel}
              </span>
            )}
          <span className="flex w-100 fs-sm text-accent-forground mt-2">
            {data.addressLabel}
          </span>
          <span className="flex items-center gap-2 w-100 fs-13 text-accent-forground mt-2">
            <EmailOutlinedIcon style={{ fontSize: '1.1rem' }} />
            {data.email}
          </span>
          {/* <span className="left width100 conctact">
            {`${
              data.phone_l
                ? parse('&#128222;&nbsp;Desk: ') + data.phone_l + ' | '
                : ''
            } `}
            {`${
              data.phone_m
                ? parse('&#128385;&nbsp;Cell: ') + data.phone_m + ' | '
                : ''
            } `}
            {`${data.fax ? parse('Fax: ') + data.fax : ''} `}
            {`${data.npi_no ? parse(' | NPINPI: ') + data.npi_no : ''} `}
          </span> */}
          <span className="flex gap-3 mt-2">
            {data?.phone_l && (
              <span className="flex items-center gap-1">
                <PhoneOutlinedIcon style={{ fontSize: '1.1rem' }} />
                <span>Desk: {data.phone_l}</span>
              </span>
            )}
            {data?.phone_m && (
              <span className="flex items-center gap-1">
                <PhoneAndroidIcon style={{ fontSize: '1.1rem' }} />
                <span>Cell: {data.phone_m}</span>
              </span>
            )}
            {data?.fax && (
              <span className="flex items-center gap-1">
                <span>Fax: {data.fax}</span>
              </span>
            )}
            {data?.fax && (
              <span className="flex items-center gap-1">
                <span>NPI: {data.npi_no}</span>
              </span>
            )}
          </span>
          <div className="pt-2 mt-2 border-t border-t-lightgray">
            <p class="fs-13 text-accent-forground">
              <strong>Notes:</strong> {data?.description}
            </p>
          </div>
        </div>
        {/* <div
          className="bodyLeftRowAction"
          onClick={() => setEditPopup({ open: true, referringMasterId: data.id })}
        >
          &#9998;
        </div> */}
      </div>
      <div
        className="flex-shrink-0 flex flex-col gap-2 mt-2"
        style={{ height: '50px' }}
      >
        <div
          className="text-primary cursor-pointer"
          onClick={() =>
            setEditPopup({ open: true, referringMasterId: data.id })
          }
        >
          <EditIcon
            style={{ fontSize: '1rem' }}
            className="border-2 border-2-primary rounded-md"
          />
        </div>
        <div
          className="text-danger cursor-pointer"
          onClick={() => onDelete(data.id)}
        >
          <DeleteOutlineOutlinedIcon style={{ fontSize: '1.2rem' }} />
        </div>
      </div>
    </div>
  );
};

export default Address;
